import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './core/layout/layout.component';
import { AuthGuardService } from './shared/services/auth-guard.service';
import { CompanyRouteGuardService } from './shared/services/company-route-guard.service';
import { LoginComponent } from './core/login/login.component';
import { HomeComponent } from './modules/home-component/home.component';
import { ForgotPasswordConfirmationComponent } from './core/forgot-password/forgot-password-confirmation/forgot-password-confirmation.component';
import { ForgotPasswordChangeComponent } from './core/forgot-password/forgot-password-change/forgot-password-change.component';
import { CompanySelectorComponent } from './modules/company-selector/company-selector.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordChangeComponent,
  },
  {
    path: 'forgot-password/confirmation',
    component: ForgotPasswordConfirmationComponent,
  },
  {
    path: 'forgot-password/change',
    component: ForgotPasswordChangeComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuardService],
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: CompanySelectorComponent,
      },
      {
        path: 'profile',
        loadChildren: () =>
          import('./modules/profile/profile.module').then(
            (m) => m.ProfileModule
          ),
      },
      {
        path: ':id',
        canActivate: [CompanyRouteGuardService],
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: HomeComponent
          },
          {
            path: 'storage',
            loadChildren: () =>
              import('./modules/storage/storage.module').then(
                (m) => m.StorageModule
              ),
          },
          {
            path: 'profile',
            loadChildren: () =>
              import('./modules/profile/profile.module').then(
                (m) => m.ProfileModule
              ),
          },
          {
            path: '**',
            redirectTo: '',
          },
        ]
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
